module.exports = __webpack_public_path__ + "static/english_circle_1-2efefc0b36bfde2a15376127d32b36ae.svg";